/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.TeaController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { TeaImportSystemVersionModel } from '../models/tea-import-system-version-model';
import { TeaSearchRequestModel } from '../models/tea-search-request-model';
import { TeaSearchResourceRequestModel } from '../models/tea-search-resource-request-model';
import { TeaSearchResourceResultItemModel } from '../models/tea-search-resource-result-item-model';
import { TeaSearchResponseModel } from '../models/tea-search-response-model';
import { TeaSystemInfoModel } from '../models/tea-system-info-model';
import { TeaUpdateResourceRequestModel } from '../models/tea-update-resource-request-model';
import { TeaUser } from '../models/tea-user';

@Injectable()
export class TeaApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public authorize(spinnerMessage: string = null): Observable<TeaUser> {
        return this.httpClient.get<TeaUser>(`/api/tea/authorize`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getSystems(spinnerMessage: string = null): Observable<TeaSystemInfoModel[]> {
        return this.httpClient.get<TeaSystemInfoModel[]>(`/api/tea/systems`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public searchResource(model: TeaSearchResourceRequestModel, spinnerMessage: string = null): Observable<TeaSearchResourceResultItemModel> {
        return this.httpClient.get<TeaSearchResourceResultItemModel>(`/api/tea/resource`,
        {params: this.createOptions(model, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public export(systemVersionId: number, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.get<void>(`/api/tea/export/${systemVersionId}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


    public updateResource(model: TeaUpdateResourceRequestModel, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/tea/resource`, model,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public search(model: TeaSearchRequestModel, spinnerMessage: string = null): Observable<TeaSearchResponseModel> {
        return this.httpClient.post<TeaSearchResponseModel>(`/api/tea/search`, model,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public import(model: TeaImportSystemVersionModel, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/tea/import`, model,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
